import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import style from '../pendingApproval/pending.module.css'
import { images } from '../../assets'
import { database } from '../../utils/firebase'
// import {fetchArchiveOpenData, fetchDelegateData} from "../../slices/patient.slices";
import {actions} from "../../slices/patient.slices";

const moment = require('moment')

let archiveListener = null
const CardComponent = (props) => {
  const { forwardPath, butttonChange, delegateData, archiveID } = props
  const [prescriptionGiven, setPrescriptionGiven] = useState(false)
  const [prescriptiontaken, setPrescriptiontaken] = useState(false)
  const [medicalNoteGiven, setMedicalNoteGiven] = useState(false)
  const [labReqGiven, setLabReqGiven] = useState(false)
  const [imageReqGiven, setImageReqGiven] = useState(false)

  const [showMedicalNoteText, setShowMedicalNoteText] = useState('')

  const [age, setAge] = useState(0)
  const [hours, setHours] = useState()
  const navigate = useNavigate()
  const [patientDate, setPatientDate] = useState('')
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const [options, setOptions] = useState({ seeMore: false })
  const me = useSelector((state) => state.app.me)
  const dispatch = useDispatch()

  useEffect(() => {
    if (delegateData) {
      let allowed = true
      if (delegateData.status === 'active') {
        allowed = true
      } else if (delegateData.status === 'pending') {
        allowed = false
      } else if (delegateData.action === 'declined') {
        allowed = false
      }

      setPrescriptionGiven(allowed)

      if(delegateData?.prescriptionData){
        setPrescriptiontaken(true)
      }
    }
  }, [delegateData])

  useEffect(async () => {
    try {
    if (delegateData) {

      const { patientID, timestamp , DOB, imagingData, labRequisitionData, medicalNotesData} = delegateData
      const patientSnapshot = await database
        .ref(`/users/${patientID}/`)
        .once('value')
      const patientData = patientSnapshot.toJSON() || {}

      setPrescriptionGiven(patientData?.history_prescriptions && patientData?.history_prescriptions[archiveID])

       setMedicalNoteGiven(patientData?.historyMedicalNotes && patientData?.historyMedicalNotes[archiveID])

       if(labRequisitionData){
        setLabReqGiven(true)
       }

       if(imagingData){
        setImageReqGiven(true)
       }
       if(!patientData?.historyMedicalNotes?.[archiveID]){
           const noteData = await getUserNote(archiveID);
          if (noteData) {
            setMedicalNoteGiven(true);
          }
       }

       console.log("Delegate Data Medical Note Text Reason:", delegateData?.medicalNoteTextReason);
       if(delegateData?.medicalNoteTextReason){
        console.log("Medical Note Text Reason:", delegateData?.medicalNoteTextReason);
        setShowMedicalNoteText(delegateData?.medicalNoteTextReason)
       }
      //  setLabReqGiven(patientData?.historyLabs && patientData?.historyLabs[archiveID])

      //  if(patientData?.historyLabs && patientData?.historyLabs[archiveID]){
        const labReq = patientData?.historyLabs?.[archiveID] || ''

        let labForms = labReq?.labForms;

        // if (!labForms || Object.keys(labForms).length === 0) {

          const labData = await getUserlab(archiveID);
          if (labData) {
            setLabReqGiven(true);
          }

          const imageData = await getUserImage(archiveID);
          if (imageData) {
              setImageReqGiven(true);
          }
        // }
         if(labReq){
          Object.values(labReq.labForms).forEach((form) => {
            if (form.fileName.includes("Lab_Requisition")) {
              setLabReqGiven(true);
            }
            if (form.fileName.includes("Image_Requisition")) {
              setImageReqGiven(true);
            }
          });
        }
       
      //  }
      const date = moment(DOB, 'MMMM DD YYYY')
      let years = moment().diff(date, 'years')

        const convertDate = date.format('YYYY-MM-DD');
        setPatientDate(convertDate)

        years = moment().diff(date, 'years')
        setAge(years)

      const hoursDiff = moment().diff(moment(timestamp), 'hours')
      setHours(hoursDiff)
    }
    }
    catch (e) {
      console.log(e)
    }
  }, [delegateData])

  const handleOptions = () => {
    setOptions({ seeMore: true })
  }

  function getPrescriptionClass() {
    const { status, action, prescriptionData } = delegateData || {};
    const rawAuth = prescriptionData?.authorization;

    const authArray = Array.isArray(rawAuth)
    ? rawAuth
    : Object.values(rawAuth || {});
    const isAuthRequired = authArray.includes("true");
  
    if (status === "active" && delegateData?.prescriptionStatus !== "declined") {
      return style.m;
    }
    if (status === "active" && delegateData?.prescriptionStatus === "declined") {
      return style.p;
    }
  
    if (status === "pending") {
      return isAuthRequired ? style.p : style.m;
    }
  
    if (status === "closed" && delegateData?.prescriptionStatus === "declined") {
      return style.p;
    }
      return style.m;
  }
  function getmedicalClass() {
    const { status} = delegateData || {};

    if (status === "active" && delegateData?.medicalNoteStatus !== "declined") {
      return style.m;
    }
    if (status === "active" && delegateData?.medicalNoteStatus === "declined") {
      return style.p;
    }
  
    if (status === "closed" && delegateData?.medicalNoteStatus === "declined") {
      return style.p;
    }
      return style.m;

  }

  const getUserlab = async (archiveID) => {
  try {
    const snapshot = await database.ref(`tempUserNode/userLabResult/${archiveID}/labForms`).once('value');
    const labData = snapshot.val();
    if (labData && Object.keys(labData).length > 0) {
      return labData;
    } else {
      console.log('No lab data found for this archive ID.');
      return null;
    }
  } catch (error) {
    console.error('Error fetching lab data:', error);
    return null;
  }
};

const getUserNote = async (archiveID) => {
  try {
    const snapshot = await database.ref(`tempUserNode/userMedicalNote/${archiveID}/notes`).once('value');
    const noteData = snapshot.val();

    if (noteData && Object.keys(noteData).length > 0) {
      return noteData;
    } else {

      const medicalNoteSnapshot = await database.ref(`medicalNotes/${archiveID}`).once('value');
      const medicalNoteData = medicalNoteSnapshot.val();
      if (medicalNoteData && Object.keys(medicalNoteData).length > 0) {
        return medicalNoteData;
      }
      console.log('No note data found for this archive ID.');
      return null;
    }
  } catch (error) {
    console.error('Error fetching lab data:', error);
    return null;
  }
};

 const getUserImage = async (archiveID) => {
  try {
    const snapshot = await database.ref(`tempUserNode/userImageResult/${archiveID}/labForms`).once('value');
    const imageData = snapshot.val();
    if (imageData && Object.keys(imageData).length > 0) {
      return imageData;
    } else {
      console.log('No lab data found for this archive ID.');
      return null;
    }
  } catch (error) {
    console.error('Error fetching lab data:', error);
    return null;
  }
};
  function getLabClass() {
    const { status,  } = delegateData || {};

    if (status === "active" && delegateData?.labStatus!== "declined") {
      return style.m;
    }
    if (status === "active" && delegateData?.labStatus === "declined") {
      return style.p;
    }
  
    if (status === "closed" && delegateData?.labStatus === "declined") {
      return style.p;
    }
      return style.m;

  }

  function getImageClass() {
    const { status,  } = delegateData || {};

    if (status === "active" && delegateData?.imagingStatus!== "declined") {
      return style.m;
    }
    if (status === "active" && delegateData?.imagingStatus === "declined") {
      return style.p;
    }
  
    if (status === "closed" && delegateData?.imagingStatus === "declined") {
      return style.p;
    }
      return style.m;

  }

  // eslint-disable-next-line no-shadow
  const navigateTo = async (patient, archive, delegateConversationID) => {
    if (butttonChange) {
      query.set('Past', butttonChange)
      query.set('archiveId', archive)
      if (delegateConversationID) {
        // query.set('delegateConversationID', delegateConversationID)
      }
    } else {
      // query.set('Id', patient)
      query.set('archiveId', archive)
      if (delegateConversationID) {
        // query.set('delegateConversationID', delegateConversationID)
      }
    }

    // change dispatch
    dispatch(actions.fetchDelegateData(archive))
    dispatch(actions.fetchArchiveOpenData(archive))

    const paramsString = query.toString()
    const url = new URL(window.location.href)
    url.search = paramsString
    navigate(forwardPath + url.search)
  }
  return (
    <div
      className={style.CardPadding}
      onClick={(event) =>
        navigateTo(delegateData.patientID, archiveID, delegateData.conversationID)
      }
    >
      <div className={style.patient}>
        <div>
          <span className={style.bold}>
            {delegateData.patientName ||  ' - '} -
          </span>
          <span> {patientDate} ({age})</span>
        </div>
        <span className={style.color}>
          {hours < 24
            ? hours + ' hrs'
            : moment(new Date(delegateData.timestamp)).format('MM/DD/YY (HH:mm)')}
        </span>
      </div>

      <div className={style.patient}>
        <div>
          <span className={style.bold}>Diagnosis:</span>
          <span>{delegateData.assessment?.substring(0, 40)  || '-'}</span>
        </div>
        <button type="button">
          <img src={images.forwardIcon} className={style.icon} alt="logo" />
        </button>
      </div>
      {me.role !== 'Doctor' && (
        <div className={style.patient}>
          <div>
            <span className={style.bold}>Doctor Name:</span>
            <span>{delegateData.doctorName}</span>
          </div>
        </div>
      )}

      <hr className={style.hr}></hr>
      <div className={style.patient}>
        <div className={style.pm}>
          {/* {prescriptiontaken &&<p className={(delegateData?.status === "active" || (delegateData?.status === "closed" && delegateData?.action !== "declined")) ? style.m:style.p}>P</p>} */}
          {prescriptiontaken && <p className={getPrescriptionClass()}>P</p>}
          {/* {medicalNoteGiven && <p className={style.m}>M</p>} */}
          {medicalNoteGiven && <p className={getmedicalClass()}>M</p>}
          {labReqGiven && <p className={getLabClass()}>L</p>}
          {imageReqGiven && <p className={getImageClass()}>I</p>}
          {showMedicalNoteText && <p className={style.medicalNoteText}>{showMedicalNoteText}</p>}
        </div>
      </div>
      <hr className={style.hr}></hr>

      {options.seeMore && (
        <div className={style.patient}>
          <div className={style.pm}>
            <p className={style.eh}>PH</p>
            <p className={style.eh}>EH</p>
          </div>
        </div>
      )}
      <div className={style.line}></div>
    </div>
  )
}

export default CardComponent
